import { GetStaticProps } from "next";
import parlors from "@/constants/parlors_detail.json";
import type { ParlorOption } from "@/types/parlorOption";

export const getStaticProps: GetStaticProps = async () => {
  // 무빈소 "장례식장 찾기" 퍼널의 관심 장례식장 체크 화면에 쓸 목록.
  //
  // 왜 빌드 타임에 추리는가
  // - parlors_detail.json 은 2.34MB(gzip 314KB)라 클라이언트로 통째 내려보낼 수 없다.
  //   행 하나를 그리는 데 필요한 필드만 남기면 gzip 47.5KB 가 된다.
  // - 이 import 는 getStaticProps 안에서만 쓰여 Next 가 클라이언트 번들에서 걷어낸다.
  //   클라이언트 모듈에서 이 JSON 을 import 하면 2.34MB 가 그대로 번들에 들어오므로
  //   추리는 위치는 반드시 여기여야 한다.
  // - 시군구는 런타임(폼 응답)에 정해져서 지역별로 미리 나눠 줄 수 없다. 전국을 다 내리고
  //   화면에서 고른 시군구로 거른다.
  //
  // is_excluded(112곳)는 폐업·철회라 "알아볼 곳"으로 제안하는 UI 에서 반드시 거른다
  // (getThreeClosestParlorFrom, MubinsoRegionParlorList 의 같은 규칙).
  const parlorOptions: ParlorOption[] = parlors
    .filter((parlor) => !parlor.is_excluded && Boolean(parlor.companyname))
    .map((parlor) => ({
      id: parlor.id,
      sigungu: parlor.sigungu,
      name: parlor.companyname,
      address: parlor.address,
      imageUrl: parlor.images?.[0]?.url ?? "",
    }));

  return {
    props: {
      pageOgTitle: "장례 예상 비용, 장례 견적 알아보기- [우리가 찾던 장례전문가, 고이]",
      pageDescription:
        "맞춤형 장례 비용을 알려드립니다. 장례식장 추천, 지역별 장례 비용 최저가, 장례식 비용 예상 견적 알아보기",
      pageKeywords:
        "후불제, 후불제상조, 선불제, 선불제상조, 후불제상조 선불제상조, 장례, 장례상담, 상조, 상조순위, 상조 기준, 상조차이, 상조비교, 상조회사, 상조회사서비스, 보람상조, 프리드라이프, 예다함",
      pageOgDescription:
        "맞춤형 장례 비용을 알려드립니다. 장례식장 추천, 지역별 장례 비용 최저가, 장례식 비용 예상 견적 알아보기",
      pageOgImage: `${process.env.NEXT_PUBLIC_CDN_URL}/platform/prepare/prepare-1-1.png`,
      parlorOptions,
    },
  };
};
export { MatchRequestContainer as default } from "containers/MatchContainer";
